import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isDisabled", "isUrlInsecure", "value", "id", "onChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useTranslation } from 'react-i18next';
import FormField from 'components/FormField';
import useUniqueId from 'hooks/useUniqueId';
import CheckboxOption from 'components/CheckboxOption';
import Hint from 'components/Hint';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function OpenInNewWindowField(_ref) {
  var isDisabled = _ref.isDisabled,
    isUrlInsecure = _ref.isUrlInsecure,
    value = _ref.value,
    id = _ref.id,
    _onChange = _ref.onChange,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId(id);
  return /*#__PURE__*/_jsxs(FormField, _objectSpread(_objectSpread({
    as: "span",
    label: t('property_new_window'),
    labelId: uniqueId
  }, otherProps), {}, {
    children: [/*#__PURE__*/_jsx(CheckboxOption, {
      fontSize: "s",
      label: t('actions_open_in_new_window'),
      id: "open-in-new-window",
      checked: !value,
      onChange: function onChange(e) {
        return _onChange(!e.target.checked);
      },
      disabled: isDisabled,
      "aria-describedby": isUrlInsecure ? 'url-insecure-hint' : undefined
    }), isUrlInsecure && /*#__PURE__*/_jsx(Hint, {
      id: "url-insecure-hint",
      my: "xs",
      children: t('hints_disable_option_for_secure_url')
    })]
  }));
}
export default OpenInNewWindowField;